var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    {
      attrs: {
        name: "custom-classes-transition",
        "enter-active-class": `animate__animated animate__${_vm.animationIn}`,
        "leave-active-class": `animate__animated animate__${_vm.animationOut}`,
      },
    },
    [
      _vm.isActive
        ? _c(
            "div",
            {
              staticClass: "modal is-active",
              style: `animation-duration: ${_vm.animationDuration}s`,
            },
            [
              _c("div", {
                staticClass: "modal-background",
                on: { click: _vm.cancel },
              }),
              _c(
                "div",
                {
                  class: {
                    "modal-content": !_vm.hasModalCard,
                    "modal-card": _vm.hasModalCard,
                  },
                  style: {
                    "min-width": `${_vm.minWidth}vw`,
                    "min-height": `${_vm.minHeight}vh`,
                    "max-height": `${_vm.maxHeight}vh`,
                  },
                },
                [
                  _vm.component
                    ? _c(
                        _vm.component,
                        _vm._b(
                          { tag: "component", on: { close: _vm.close } },
                          "component",
                          _vm.props,
                          false
                        )
                      )
                    : _vm.content
                    ? _c("div", {
                        domProps: { innerHTML: _vm._s(_vm.content) },
                      })
                    : _vm._t("default"),
                ],
                2
              ),
              _vm.canCancel
                ? _c("button", {
                    staticClass: "modal-close is-large",
                    on: { click: _vm.cancel },
                  })
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }